import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../WarrantyFrame';
import CheckListTable from '../../../checkListTable'

export default function InsForm24MT(props) {
    const { currentState, setCurrentState } = useContext(UserInputData);
    const { control, getValues, setValue, } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(0)
    const [resetValues, setResetValues] = useState(false)

    useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])


    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(isComplete + 1)
        }
    }, [props.isEffectDone])

    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete === 2) {
            setResetValues(!resetValues)
        }
    }, [isComplete])


    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };
    return (
        <React.Fragment>
            <Typography sx={{ fontSize: '2rem', }}>3　定期点検項目</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>建物外部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.整地</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Seichi"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'seichiStatus',
                                        label: '整地の状態',
                                        value: parseInt(getValues("seichiStatus"))
                                    }, {
                                        id: 'seichiHaisuiStatus',
                                        label: '排水桝の状態',
                                        value: parseInt(getValues("seichiHaisuiStatus"))
                                    }, {
                                        id: 'seichiSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("seichiSonota"))
                                    }]}
                                    value />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>2.基礎</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Kiso"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'kisoHyomen',
                                        label: '基礎表面',
                                        value: parseInt(getValues("kisoHyomen"))
                                    }, {
                                        id: 'kisoKankiStatus',
                                        label: '換気の状態',
                                        value: parseInt(getValues("kisoKankiStatus"))
                                    }, {
                                        id: 'kisoSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("kisoSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>3.外装材</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Gaisou"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaisoWare',
                                        label: '割れ、欠け、ヒビ',
                                        value: parseInt(getValues("gaisoWare"))
                                    }, {
                                        id: 'gaisoJoint',
                                        label: 'ジョイント部シーリング',
                                        value: parseInt(getValues("gaisoJoint"))
                                    }, {
                                        id: 'gaisoToriaibu',
                                        label: '取合部シーリング',
                                        value: parseInt(getValues("gaisoToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>3.外壁</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Gaiheki"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaihekiPanel',
                                        label: '壁パネルの状態',
                                        value: parseInt(getValues("gaihekiPanel"))
                                    }, {
                                        id: 'gaihekiAmamizu',
                                        label: '雨水の侵入',
                                        value: parseInt(getValues("gaihekiAmamizu"))
                                    }, {
                                        id: 'gaihekiSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("gaihekiSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>4.バルコニー</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Barukoni"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'barukoniAmamizu',
                                        label: '雨水の侵入',
                                        value: parseInt(getValues("barukoniAmamizu"))
                                    }, {
                                        id: 'barukoniTukiStatus',
                                        label: '柱化粧飾りの通気状態',
                                        value: parseInt(getValues("barukoniTukiStatus"))
                                    }, {
                                        id: 'barukoniMokubu',
                                        label: '木部の劣化',
                                        value: parseInt(getValues("barukoniMokubu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>5.屋根（目視）</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="Yane"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'yaneTakezai',
                                        label: '屋根葺材',
                                        value: parseInt(getValues("yaneTakezai"))
                                    }, {
                                        id: 'yaneAmamizu',
                                        label: '雨水の侵入',
                                        value: parseInt(getValues("yaneAmamizu"))
                                    }, {
                                        id: 'yaneBankin',
                                        label: '板金の状態',
                                        value: parseInt(getValues("yaneBankin"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>6.塗装全般</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="TosouGaibu"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'tosoTategu',
                                        label: '外部建具',
                                        value: parseInt(getValues("tosoTategu"))
                                    }, {
                                        id: 'tosoGaisozai',
                                        label: '外装材の状態',
                                        value: parseInt(getValues("tosoGaisozai"))
                                    }, {
                                        id: 'tosoBaruconi',
                                        label: 'バルコニー',
                                        value: parseInt(getValues("tosoBaruconi"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>7.フラワーBOX</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="FlowerBox"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'flowerTorituke',
                                        label: '取付の状態',
                                        value: parseInt(getValues("flowerTorituke"))
                                    }, {
                                        id: 'flowerKanagu',
                                        label: '金具の状態',
                                        value: parseInt(getValues("flowerKanagu"))
                                    }, {
                                        id: 'flowerToriaibu',
                                        label: '取合部',
                                        value: parseInt(getValues("flowerToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>8.妻飾り</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="TsumaKazari"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'tatemonoTorituke',
                                        label: '取付の状態',
                                        value: parseInt(getValues("tatemonoTorituke"))
                                    }, {
                                        id: 'tatemonoKanagu',
                                        label: '金具の状態',
                                        value: parseInt(getValues("tatemonoKanagu"))
                                    }, {
                                        id: 'tatemonoToriaibu',
                                        label: '取合部',
                                        value: parseInt(getValues("tatemonoToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>外部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.玄関ドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="genkan"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'genkanKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("genkanKaihei"))
                                    }, {
                                        id: 'genkanPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("genkanPakkin"))
                                    }, {
                                        id: 'genkanKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("genkanKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>2.バルコニードア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="barukoni"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'barukoniKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("barukoniKaihei"))
                                    }, {
                                        id: 'barukoniPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("barukoniPakkin"))
                                    }, {
                                        id: 'barukoniKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("barukoniKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>3.スライディングドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="suraidhing"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'suraidhingKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("suraidhingKaihei"))
                                    }, {
                                        id: 'suraidhingPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("suraidhingPakkin"))
                                    }, {
                                        id: 'suraidhinguKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("suraidhinguKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>4.窓</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="window"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'windowKaihei',
                                        label: '開閉状況',
                                        value: parseInt(getValues("windowKaihei"))
                                    }, {
                                        id: 'windowPakkin',
                                        label: 'パッキン、金具',
                                        value: parseInt(getValues("windowPakkin"))
                                    }, {
                                        id: 'windowKyuyu',
                                        label: '給油',
                                        value: parseInt(getValues("windowKyuyu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>5.共通 ; 開口部防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="common"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'commonSanho',
                                        label: '三方シーリング',
                                        value: parseInt(getValues("commonSanho"))
                                    }, {
                                        id: 'commonMIzukiri',
                                        label: '水切差込部',
                                        value: parseInt(getValues("commonMIzukiri"))
                                    }, {
                                        id: 'commonRyotan',
                                        label: '両端シーリング',
                                        value: parseInt(getValues("commonRyotan"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>建物内部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.クロス</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="Cross"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kurosuHagare',
                                            label: '剝れ',
                                            value: parseInt(getValues("kurosuHagare"))
                                        }, {
                                            id: 'kurosuUki',
                                            label: '浮き',
                                            value: parseInt(getValues("kurosuUki"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.階段</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="Kaidan"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'kaidanDanita',
                                            label: '段板',
                                            value: parseInt(getValues("kaidanDanita"))
                                        }, {
                                            id: 'kaidanTesuri',
                                            label: '手摺の固定状況',
                                            value: parseInt(getValues("kaidanTesuri"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.床</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="Yuka"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'yukaNari',
                                            label: '床鳴り',
                                            value: parseInt(getValues("yukaNari"))
                                        }, {
                                            id: 'yukaUki',
                                            label: '浮き、不陸',
                                            value: parseInt(getValues("yukaUki"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.内部ドア</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="naibu"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'naibuKaihei',
                                            label: '開閉状況',
                                            value: parseInt(getValues("naibuKaihei"))
                                        }, {
                                            id: 'naibuPakkin',
                                            label: 'パッキン、金具',
                                            value: parseInt(getValues("naibuPakkin"))
                                        }, {
                                            id: 'naibuKyuyu',
                                            label: '給油',
                                            value: parseInt(getValues("naibuKyuyu"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                    <Typography sx={{ fontSize: '2rem', }}>水回り</Typography>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>1.浴室</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="yokushitu"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'yokushituKigu',
                                                label: '各種器具',
                                                value: parseInt(getValues("yokushituKigu"))
                                            }, {
                                                id: 'yokushituShiring',
                                                label: 'シーリング',
                                                value: parseInt(getValues("yokushituShiring"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>2.キッチン</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="kittin"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'kittinKigu',
                                                label: '各種器具',
                                                value: parseInt(getValues("kittinKigu"))
                                            }, {
                                                id: 'kittinSonota',
                                                label: 'その他',
                                                value: parseInt(getValues("kittinSonota"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>3.洗面台</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="senmen"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'senmenKigu',
                                                label: '各種器具',
                                                value: parseInt(getValues("senmenKigu"))
                                            }, {
                                                id: 'senmenSonota',
                                                label: 'その他',
                                                value: parseInt(getValues("senmenSonota"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>4.洗濯機置場</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="sentaku"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'sentakuKigu',
                                                label: '各種器具',
                                                value: parseInt(getValues("sentakuKigu"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                    <Typography sx={{ fontSize: '2rem', }}>設備</Typography>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>1.24時間換気</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="kanki"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'kankiFilter',
                                                label: 'フィルター',
                                                value: parseInt(getValues("kankiFilter"))
                                            }, {
                                                id: 'kankiNetkoukan',
                                                label: '熱交換素子',
                                                value: parseInt(getValues("kankiNetkoukan"))
                                            }, {
                                                id: 'kankiKanrei',
                                                label: '寒冷地仕様',
                                                value: parseInt(getValues("kankiKanrei"))
                                            },]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>2.局所換気</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="kyokusyo"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'kyokusyoFilter',
                                                label: 'フィルター',
                                                value: parseInt(getValues("kyokusyoFilter"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>3.冷暖房設備</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="reidanbo"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'reidanboEakon',
                                                label: 'エアコンの状況',
                                                value: parseInt(getValues("reidanboEakon"))
                                            }, {
                                                id: 'reidanboKanrei',
                                                label: '寒冷地仕様',
                                                value: parseInt(getValues("reidanboKanrei"))
                                            }, {
                                                id: 'reidanboSuraimu',
                                                label: 'スライム対策',
                                                value: parseInt(getValues("reidanboSuraimu"))
                                            },]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>4.貯湯タンク</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 2 }}>
                                <Controller
                                    control={control}
                                    name="reidanbo"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'tyoyuSurabu',
                                                label: 'スラブの状態',
                                                value: parseInt(getValues("tyoyuSurabu"))
                                            }, {
                                                id: 'tyoyuAnker',
                                                label: 'アンカーボルト',
                                                value: parseInt(getValues("tyoyuAnker"))

                                            }, {
                                                id: 'tyoyuHontai',
                                                label: '本体脚',
                                                value: parseInt(getValues("tyoyuHontai"))
                                            },]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                    <Typography sx={{ fontSize: '2rem', }}>特殊</Typography>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>1.床下</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                                <Controller
                                    control={control}
                                    name="baibu"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'yukasitaStatus',
                                                label: '床下空間の状態',
                                                value: parseInt(getValues("yukasitaStatus"))
                                            }, {
                                                id: 'yukasitaHaikan',
                                                label: '配管',
                                                value: parseInt(getValues("yukasitaHaikan"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                            <Typography sx={{ fontSize: '1.7rem', }}>2.小屋裏</Typography>
                            <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                                <Controller
                                    control={control}
                                    name="koyaura"
                                    render={() => (
                                        <CheckListTable setValue={handleCheckListValues}
                                            resetValues={resetValues}
                                            RowTitle={[{
                                                id: 'koyauraTuki',
                                                label: '通気',
                                                value: parseInt(getValues("koyauraTuki"))
                                            }, {
                                                id: 'koyauraDannetuzai',
                                                label: '断熱材',
                                                value: parseInt(getValues("koyauraDannetuzai"))
                                            }]} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid >
            </Grid >
        </React.Fragment>
    )
}
